import { Breadcrumbs, Typography, Link, Stack } from "@mui/material";
import { Link as LinkTo } from 'react-router';
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { BackButton } from "../../../../../common/components/back_button";
import { DefaultFormDatePickerInput } from "../../../../../common/components/default_form_date_picker_input";
import { DefaultFormRadioGroupInput } from "../../../../../common/components/default_form_radio_group_input";
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete";
import { GenerateOrdemComprasCadastroColumnDefinition } from "./columns";
import { CustomStyledDataGrid } from "./components/custom_styled_data_grid";
import { useMemo } from "react";
import { OrdemCompraProdutoServico } from "../../../domain/models/ordem_compra_detalhes";
import { FormMaskedInput } from "../../../../../common/components/masked_inputs/react_forms/form_masked_input";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { useOrdemCompraCancelarViewModel } from "../../viewModels/ordem_compra_cancelar_view_model";
import { CancelarOrdemCompraModal } from "./components/cancelar_ordem_compra_modal";
import { isValidId } from "../../../../../common/utils/utils";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";

import AlertError from "../../../../../common/components/alert_error";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import BottomBar from "../../../../../common/components/bottom_bar";
import dayjs from "dayjs";
import DefaultInput from "../../../../../common/components/default_input";

/**
 * OrdemCompraCancelar
 */

export const OrdemCompraCancelar = () => {
  const viewModel = useOrdemCompraCancelarViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateOrdemComprasCadastroColumnDefinition({
      onActionEditar: () => { },
      onActionDeletar: () => { },
    });
  }, [
  ]);

  return (
    <>
      {/**
        * PageTopBar
        */}

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              {
                (viewModel.ordemCompraCanceladoStatus && viewModel.ordemCompraCanceladoStatus.cancelado !== true) &&
                <div className="w-[15rem]">
                  <PrimaryButton
                    buttonColor="red"
                    startIcon={<DynamicIcon nameIcon="Delete" size={25} className="text-white" />}
                    onMouseDown={e => {
                      viewModel.handleCancelarOrdemCompraOpenState(true);
                      e.preventDefault();
                    }}>
                    Cancelar Ordem de Compra
                  </PrimaryButton>
                </div>
              }

              <div className="w-[115px]">
                <PrimaryButton
                  buttonColor="yellow"
                  onMouseDown={e => {
                    viewModel.handleReport();
                    e.preventDefault();
                  }}>
                  Relatório
                </PrimaryButton>
              </div>

              <BackButton
                onClick={viewModel.handleBack}
              />
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <form onSubmit={viewModel.handleOrdemCompraSubmit}>
        <div className="flex w-full gap-6 flex-col py-10 px-4 mb-16">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Compras
            </Link>
            <Link underline="hover" color="inherit" component='span'>
              <LinkTo to='/OrdemCompra_lista_cancelar'>
                Cancelar Ordem de Compra
              </LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Cancelar Ordem de Compra
            </Typography>
          </Breadcrumbs>

          <div className="flex flex-col gap-2">
            <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
              <div className="flex gap-2 items-center w-full">
                <h1 className="text-3xl font-medium text-black dark:text-white">Cancelar Ordem de Compra</h1>
                <RefreshButton onClick={viewModel.handleReload} />
              </div>

              <div className="w-full justify-end flex gap-2">
              </div>
            </div>
          </div>
          {
            viewModel.errorMessage !== undefined
              ? (
                <div className="w-full">
                  <AlertError
                    messageErro={viewModel.errorMessage}
                    onTryAgain={viewModel.handleReload} />
                </div>
              ) : (
                <>
                  {
                    (viewModel.ordemCompraCanceladoStatus && viewModel.ordemCompraCanceladoStatus.cancelado === true) &&
                    <div className="w-full flex flex-col gap-2 p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-red-500">
                      <span className="text-red-500 font-bold">
                        <DefaultInput
                          id='cancelamento-input'
                          name='cancelamento'
                          label='Motivo cancelamento'
                          readOnly={true}
                          value={viewModel.ordemCompraCanceladoStatus.motivo}
                          multiline={true}
                          rows={7}
                          sx={{
                            '& .MuiFormLabel-root.MuiInputLabel-root': {
                              color: '#ef4444',
                            },
                            '& .MuiInputBase-root.MuiOutlinedInput-root': {
                              color: '#ef4444',
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#ef4444',
                              },
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#ef4444',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#ef4444',
                            },
                          }}
                        />
                      </span>

                      <span className="text-red-500 font-normal">
                        Ordem de compra <span className="font-bold px-1">CANCELADA</span> pelo usuário
                        <span className="font-bold px-1">{viewModel.ordemCompraCanceladoStatus.UsuarioCancelada}</span>
                        no dia <span className="font-bold px-1">{dayjs.utc(viewModel.ordemCompraCanceladoStatus.dataCancelada).local().format('DD/MM/YYYY')}</span>!
                      </span>
                    </div>
                  }

                  <div className="w-full flex flex-col gap-2 p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-border-light-mode dark:border-border-dark-mode text-black dark:text-white">
                    <h1 className="text-xl text-black dark:text-white font-semibold">Informações Gerais</h1>
                    <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-2 gap-y-4">
                      <DefaultFormInput
                        name='nroOC'
                        label='Nº da OC'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      {
                        (viewModel.atributoCompra && viewModel.atributoCompra.exibirDataCadastro) &&
                        <DefaultFormDatePickerInput
                          name='dataCadastro'
                          label='Data de Cadastro'
                          readOnly={true}
                          reactHookForm={viewModel.hookForm}
                        />
                      }


                      <DefaultFormInput
                        name='nroColeta'
                        label='Nº Coleta'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormDatePickerInput
                        name='dataOC'
                        label='Data da OC'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='centroCusto'
                        label='Centro Custo'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormAutocomplete
                        name='subconta'
                        label='Subconta'
                        options={viewModel.subcontasDropdown}
                        getOptionLabel={x => x.title}
                        getOptionKey={x => x.id}
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='comprador'
                        label='Comprador'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='respAprovacao'
                        label='Resp. Aprovação'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormDatePickerInput
                        name='dataEntrega'
                        label='Data de Entrega'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='nroCNO'
                        label='N° CNO'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    <DefaultFormRadioGroupInput
                      name='entrega'
                      label='Entrega'
                      options={viewModel.entregaOptions}
                      reactHookForm={viewModel.hookForm}
                    />

                    <DefaultFormRadioGroupInput
                      name='respDescarga'
                      label='Responsabilidade Descarga dos Materiais'
                      options={viewModel.respDescargaOptions}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>

                  <div className="w-full flex flex-col gap-2 p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-border-light-mode dark:border-border-dark-mode text-black dark:text-white">
                    <h1 className="text-xl text-black dark:text-white font-semibold">Informações do Fornecedor</h1>
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4">
                      <DefaultFormInput
                        name='for_nomeFantasia'
                        label='Nome Fantasia'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_cnpj'
                        label='CNPJ'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_razaoSocial'
                        label='Razão Social'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_cpf'
                        label='CPF'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_contato'
                        label='Contato'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <div className="w-full col-span-1 lg:col-span-2">
                        <DefaultFormInput
                          name='for_email'
                          label='Email'
                          readOnly={true}
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <DefaultFormInput
                        name='for_incricaoEstadual'
                        label='Inscrição Estadual'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_telFixo'
                        label='Tel Fixo'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_inscricaoMunicipal'
                        label='Inscrição Municipal'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_telCelular'
                        label='Tel Celular'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <div className="w-full h-[1rem] col-span-1 lg:col-span-2"></div>

                      <DefaultFormInput
                        name='for_cep'
                        label='Cep'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_cidade'
                        label='Cidade'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_rua'
                        label='Rua/Bairro/Alameda'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_numero'
                        label='Número'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_complemento'
                        label='Complemento'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_bairro'
                        label='Bairro'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_estado'
                        label='Estado'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='for_pais'
                        label='País'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    <h1 className="text-xl text-black dark:text-white font-semibold mt-16">Informações para Faturamento</h1>
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4">
                      <div className="w-full col-span-1 lg:col-span-2">
                        <DefaultFormAutocomplete
                          name='informacoesFaturamento'
                          label='Informação para Faturamento'
                          options={viewModel.informacoesFaturamentoDropdown}
                          getOptionLabel={x => x.nomeFantasia}
                          getOptionKey={x => x.idInformacaoFaturamento}
                          reactHookForm={viewModel.hookForm}
                          onChangeValue={viewModel.handleInformacaoFaturamentoChange}
                        />
                      </div>

                      <div className="w-full h-[1rem] col-span-1 lg:col-span-2 border-b border-border-light-mode dark:border-border-dark-mode"></div>

                      <DefaultFormInput
                        name='fat_nomeFantasia'
                        label='Nome Fantasia'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_cnpj'
                        label='CNPJ'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_razaoSocial'
                        label='Razão Social'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_cpf'
                        label='CPF'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_contato'
                        label='Contato'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <div className="w-full col-span-1 lg:col-span-2">
                        <DefaultFormInput
                          name='fat_email'
                          label='Email'
                          readOnly={true}
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <DefaultFormInput
                        name='fat_incricaoEstadual'
                        label='Inscrição Estadual'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_telFixo'
                        label='Tel Fixo'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_inscricaoMunicipal'
                        label='Inscrição Municipal'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_telCelular'
                        label='Tel Celular'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <div className="w-full h-[1rem] col-span-1 lg:col-span-2"></div>

                      <DefaultFormInput
                        name='fat_cep'
                        label='Cep'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_cidade'
                        label='Cidade'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_rua'
                        label='Rua/Bairro/Alameda'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_numero'
                        label='Número'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_complemento'
                        label='Complemento'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_bairro'
                        label='Bairro'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_estado'
                        label='Estado'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='fat_pais'
                        label='País'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    {
                      (viewModel.ordemCompra && viewModel.ordemCompra.tipoEntrega === 'E') &&
                      <>
                        <h1 className="text-xl text-black dark:text-white font-semibold mt-16">Informações para Entrega</h1>
                        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4">
                          <div className="w-full col-span-1 lg:col-span-2">
                            <DefaultFormAutocomplete
                              name='endereco'
                              label='Endereço'
                              options={viewModel.centroCustoEnderecoDropdown}
                              getOptionLabel={x => x.tipoEndereco ?? ''}
                              getOptionKey={x => x.idCentroCustoEndereco}
                              reactHookForm={viewModel.hookForm}
                              onChangeValue={viewModel.handleCentroCustoEnderecoChange}
                            />
                          </div>

                          <div className="w-full h-[1rem] col-span-1 lg:col-span-2 border-b border-border-light-mode dark:border-border-dark-mode"></div>

                          <FormMaskedInput
                            name='ent_cep'
                            label='Cep'
                            mask='00.000-000'
                            maskPlaceholder='__.___-___'
                            reactHookForm={viewModel.hookForm}
                            onChange={viewModel.handleEnderecoCepChange}
                          />

                          <DefaultFormInput
                            name='ent_cidade'
                            label='Cidade'
                            reactHookForm={viewModel.hookForm}
                          />

                          <DefaultFormInput
                            name='ent_rua'
                            label='Rua/Bairro/Alameda'
                            reactHookForm={viewModel.hookForm}
                          />

                          <DefaultFormInput
                            name='ent_numero'
                            label='Número'
                            reactHookForm={viewModel.hookForm}
                          />

                          <DefaultFormInput
                            name='ent_complemento'
                            label='Complemento'
                            reactHookForm={viewModel.hookForm}
                          />

                          <DefaultFormInput
                            name='ent_bairro'
                            label='Bairro'
                            reactHookForm={viewModel.hookForm}
                          />

                          <DefaultFormInput
                            name='ent_estado'
                            label='Estado'
                            reactHookForm={viewModel.hookForm}
                          />

                          <DefaultFormInput
                            name='ent_pais'
                            label='País'
                            reactHookForm={viewModel.hookForm}
                          />
                        </div>
                      </>
                    }

                    <h1 className="text-xl text-black dark:text-white font-semibold mt-16">Informações Bancárias</h1>
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4">
                      <div className="w-full col-span-1 lg:col-span-2">
                        <DefaultFormAutocomplete
                          name='banco'
                          label='Banco'
                          options={viewModel.bancosDropdown}
                          getOptionLabel={x => x.descricao}
                          getOptionKey={x => x.idBanco}
                          reactHookForm={viewModel.hookForm}
                          onChangeValue={viewModel.handleBancoChange}
                        />
                      </div>

                      <div className="w-full h-[1rem] col-span-1 lg:col-span-2 border-b border-border-light-mode dark:border-border-dark-mode"></div>

                      <div className="w-full col-span-1 lg:col-span-2">
                        <DefaultFormRadioGroupInput
                          name='ban_tipoConta'
                          label='Tipo de Conta'
                          options={viewModel.tipoContaOptions}
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <DefaultFormInput
                        name='ban_banco'
                        label='Banco'
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='ban_agencia'
                        label='Agência'
                        reactHookForm={viewModel.hookForm}
                      />

                      <div className="w-full flex flex-row gap-2 items-center">
                        <DefaultFormInput
                          name='ban_conta'
                          label='Conta'
                          reactHookForm={viewModel.hookForm}
                        />

                        <span className="mx-1">-</span>

                        <div className="w-[6rem]">
                          <DefaultFormInput
                            name='ban_digito'
                            label='Digito'
                            reactHookForm={viewModel.hookForm}
                          />
                        </div>
                      </div>

                      <DefaultFormInput
                        name='ban_operacao'
                        label='Operação'
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='ban_favorecido'
                        label='Favorecido'
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='ban_cpfcnpj'
                        label='CPF/CNPJ'
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='ban_pix'
                        label='Pix'
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    <div className="w-full h-[1rem] mt-8 mb-1 col-span-1 lg:col-span-2 border-b border-border-light-mode dark:border-border-dark-mode"></div>

                    <DefaultFormInput
                      name='informacoesGerais'
                      label='Informações Gerais'
                      multiline={true}
                      rows={7}
                      reactHookForm={viewModel.hookForm}
                    />

                    <DefaultFormInput
                      name='observacoes'
                      label='Observações'
                      multiline={true}
                      rows={7}
                      reactHookForm={viewModel.hookForm}
                    />

                    <h1 className="text-xl text-black dark:text-white font-semibold mt-16">Informações do Produto/Serviço</h1>
                    <Stack spacing={0}>
                      <CustomStyledDataGrid
                        tableName="ordem_compras_cadastro"
                        disableRowSelectionOnClick={true}
                        disableColumnMenu={false}
                        getRowId={(row: OrdemCompraProdutoServico) => row.idOrdemCompraProdutoServico}
                        columns={columnsDefinition}
                        loading={viewModel.loading}
                        rows={viewModel.produtosServicos}
                        information={viewModel.information}
                      />

                    </Stack>
                  </div>
                </>
              )
          }
        </div>

        {/**
          * BottomBar
          */}

        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {
                isValidId(viewModel.idOrdemCompra) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                  <span className="text-xs">
                    Historico de alterações
                  </span>
                </PrimaryButton>
              }
            </div>

            <div className="flex flex-row gap-4">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handleBack}>
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving
                  ? (
                    <PrimaryButton>
                      Salvando...
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      {/**
        * Modals
        */}

      <CancelarOrdemCompraModal
        open={viewModel.cancelarOrdemCompraModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        onClose={() => viewModel.handleCancelarOrdemCompraOpenState(false)}
        onSubmit={viewModel.handleCancelarOrdemCompraSubmit}
      />

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />
    </>
  );
}